/**
 * ShareSection — Shared social share row for all FoodCard variants.
 * Collapsed by default — tap to expand social buttons.
 * Instagram | WhatsApp | LinkedIn | Copy Link
 */
import { useState } from 'react';
import { Share2, Link2 as LinkIcon, ChevronDown } from 'lucide-react';
import { InstagramSvg, WhatsAppSvg, LinkedInSvg } from './shared';

const ShareSection = ({
  onSocialShare,
  shareCount = 0,
  testId,
  compact = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const btnSz = compact ? 'w-9 h-9' : 'w-10 h-10';

  const handleShare = (platform) => {
    onSocialShare(platform);
  };

  return (
    <div className={`${compact ? 'pt-3' : 'mt-4 pt-4'} border-t border-gray-100`} data-testid={`share-section-${testId}`}>
      {/* Toggle Row */}
      <button
        onClick={() => setIsOpen(prev => !prev)}
        className="flex items-center justify-between w-full group"
        data-testid={`share-toggle-${testId}`}
      >
        <div className="flex items-center gap-2">
          <Share2 className={`${compact ? 'w-4 h-4' : 'w-[18px] h-[18px]'} text-[#FF6B35]`} />
          <span className="text-xs font-semibold text-[#FF6B35]" data-testid={`share-count-${testId}`}>
            Share
          </span>
        </div>
        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Expandable Social Buttons */}
      <div
        className={`grid transition-all duration-250 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3' : 'grid-rows-[0fr] opacity-0'}`}
        data-testid={`share-buttons-${testId}`}
      >
        <div className="overflow-hidden">
          <div className="flex items-center gap-3">
            <button onClick={() => handleShare('instagram')}
              className={`${btnSz} rounded-full flex items-center justify-center transition-all active:scale-90 hover:scale-105 shadow-sm`}
              style={{ background: 'linear-gradient(135deg, #833AB4, #E1306C, #F77737)' }}
              data-testid={`share-instagram-${testId}`}>
              <InstagramSvg />
            </button>
            <button onClick={() => handleShare('whatsapp')}
              className={`${btnSz} rounded-full bg-[#25D366] flex items-center justify-center transition-all active:scale-90 hover:scale-105 shadow-sm`}
              data-testid={`share-whatsapp-${testId}`}>
              <WhatsAppSvg />
            </button>
            <button onClick={() => handleShare('linkedin')}
              className={`${btnSz} rounded-full bg-[#0A66C2] flex items-center justify-center transition-all active:scale-90 hover:scale-105 shadow-sm`}
              data-testid={`share-linkedin-${testId}`}>
              <LinkedInSvg />
            </button>
            <button onClick={() => handleShare('copy')}
              className={`${btnSz} rounded-full bg-gray-100 backdrop-blur-sm border border-gray-200 flex items-center justify-center transition-all active:scale-90 hover:scale-105 hover:bg-gray-200`}
              data-testid={`share-copy-${testId}`}>
              <LinkIcon className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareSection;
